<template>



    <div class="modal modal-active">
      <div class="modal-dialog">
         <div class="modal-content">
           <div class="modal-header">
             <div class="modal-title">{{_lang('Publish')}}</div>
             <span class="close" @click="close">&times;</span>
          </div>
           <div class="modal-body">
               <div class="form-group">
                <dl>
                    <dt>{{_lang('Domain')}}</dt>
                    <dd>{{project.domain}}</dd>
                </dl>
               </div>

                <div class="mt-2">
                    <button v-if="!isDeploying" class="btn btn-primary" @click="publish">{{_lang('Publish')}}!</button>
                </div>

                    <div v-if="isDeploying">
                      <progress />
                      <p>{{deployMessages[deployMessageIndex]}}...</p>
                    </div>

                    <div class="form-group mt-2" v-if="publishResponse">
                        <label>{{_lang('Response')}}:</label>
                        <div class="alert alert-info">{{publishResponse}}</div>
                    </div>

                    <a v-if="showlink" :href="deployUrl" class="btn btn-success mt-2" target="_blank">{{deployUrl}}</a>


           </div>
         </div>
       </div>
    </div>


</template>

<script>
import axios from 'axios';
export default {
    props:['project','active'],

    data(){
        return {
            publishResponse:'',
            isDeploying:false,
            showlink:false,
            deployExpectedTime:10,
            deployMessages:[
              this._lang('connecting deploy server'),
              this._lang('converting links'),
              this._lang('uploading assets'),
              this._lang('optimizing'),
            ],
            deployMessageIndex:0,
        }
    },
    computed:{
      msEach(){
        return this.deployExpectedTime/this.deployMessages.length * 1000;
      },
      deployUrl(){
        return 'https://'+this.project.domain;
      }
    },
    methods:{

        close(){
            this.$emit('close');
        },
        updateDeployProgress(){
          setTimeout(()=>{
            if(this.deployMessageIndex>=this.deployMessages.length-1) return;
            this.deployMessageIndex++;
            this.updateDeployProgress();
          },this.msEach);
        },
    publish(){

      this.publishResponse = '';

      this.deployMessageIndex = 0;
      this.updateDeployProgress();
      this.isDeploying = true;
      this.showlink = false;

      axios({
        method: 'post',
        url: '/api/publish/'+this.project.id,
      }).then((res) => {
        //this.publishResponse = res.data;
        this.isDeploying = false;
        this.showlink = true;
      }).catch(err=>{
        this.isDeploying = false;
        this.publishResponse = JSON.stringify(err.response);
      });



    },

    },


}
</script>

<style scoped>

</style>
